import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

/**
 * 简单的单 key:value 的打点
 * @param action
 * @param label
 */
export var sendEvent = function sendEvent(action, label) {
  Cordova.exec(function (result) {
    console.info("sendEvent:", result);
  }, function (error) {
    console.info("sendEvent error:", error);
  }, "ThirdPartyPlugin", "UmengLogWithParam", [_defineProperty({}, action, {
    event_label: label ? label : "null"
  })]);
};
/**
 * 多值打点
 * @param action
 * @param map  Object类型
 */

export var sendMapEvent = function sendMapEvent(action, map) {
  console.log("sendMapEvent:", _defineProperty({}, action, map));
  Cordova.exec(function (result) {
    console.info("sendEvent:", result);
  }, function (error) {
    console.info("sendEvent error:", error);
  }, "ThirdPartyPlugin", "UmengLogWithParam", [_defineProperty({}, action, map)]);
};